import './informasjonstekst.css'
import { useCallback } from 'react'
import { connect } from 'react-redux'
import { INFORMASJONSTEKST_BETA } from '../../ressurser/Konstanter'
import { selectFeatureToggle } from '../raderogkolonner/raderOgKolonnerSelector'
import useBrukertypeStatistikk from '../loggingavpublikum/useBrukertypeStatistikk'

import { selectSistOppdatert, selectInformasjonstekst } from './InformasjonstekstSelector'

/**
 * Informasjonstekst er en container som inneholder forklaringsteksten om hva nettsiden er ment til å brukes for. I dette tilfellet teksten rett under header.
 * Komponenten henter informasjon om når siste data ble hentet.
 */

const Informasjonstekst = (props) => {
    const { featureToggle, informasjonstekst } = props
    const [harValgtBrukertype] = useBrukertypeStatistikk()

    const fokuserOverskrift = useCallback(
        (overskriftElement) => {
            if (overskriftElement && harValgtBrukertype) {
                overskriftElement.focus()
            }
        },
        [harValgtBrukertype]
    )

    return (
        <div className="informasjonstekst">
            <h1 className="sokITrafikkuroverskrift" tabIndex="-1" ref={fokuserOverskrift}>
                Søk i Trafikkulykkesregisteret
            </h1>
            {featureToggle && featureToggle.beta && <p>{INFORMASJONSTEKST_BETA}</p>}
            <p>{informasjonstekst.del1 + informasjonstekst.utvidet}</p>
        </div>
    )
}

const mapStateToProps = (state) => ({
    sistOppdatert: selectSistOppdatert(state),
    featureToggle: selectFeatureToggle(state),
    informasjonstekst: selectInformasjonstekst(state)
})

export const InformasjonstekstContainer = connect(mapStateToProps, null)(Informasjonstekst)
